<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('title')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="title"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('version')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="version"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('internal_note')">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="internal_note"/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('released_by_uuid')">
              <user-select-input-widget attribute="released_by_uuid" @select="onReleasedBySelect"
                                        :model="searchModel"
                                        :label="false"
                                        :options="{placeholder: $t('Released By')}" is-search/>
            </div>
            <div class="input-wrapper" v-if="!excludeSearchFields.includes('status')">
              <input-widget :model="searchModel"
                            attribute="status"
                            value-field="value"
                            display-field="${item.key}"
                            type="select2"
                            :label="false"
                            :options="{placeholder: $t('Status')}"
                            :items="statuses"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import UserSelectInputWidget from "@/core/widgets/UserSelectInputWidget.vue";
  import i18n from "@/shared/i18n";

  const {mapState, mapActions} = createNamespacedHelpers('conditionReports');

  export default {
    name: "ConditionReportSearch",
    components: {UserSelectInputWidget, InputWidget},
    props: {
      excludeSearchFields: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        extraFilters: state => state.tableData[state.tableSource].extraFilters,
        statuses: state => state.statuses
      }),
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.resetTable();
      },
      async onReleasedBySelect(released_by) {
        this.updateSearchModel({released_by});
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
